import { PageLayoutOwnProps } from '@shared/components/page-layout/model'
import { Empty } from '@shared/models'
import { NextPageFC } from '@shared/models/next-fc'
import { requireNotNull } from '@shared/pipes/require-not-null'
import { ipotekaBezDohodaMainBlock } from 'data/ipotekaBezDohodaMainBlock'
import { IpotekaBezDohodaScreen } from 'screens/ipoteka-bez-dohoda'

import {
	RegionalPagesPath,
	regionalPagesProps,
} from '../../../regions/runtime-components/pages-props'
import { serverSideResolveCity } from '../../../ssr-resolvers/next-ssr-resolvers'

const IpotekaBezDohodaPage: NextPageFC<Empty, PageLayoutOwnProps> = () =>
	IpotekaBezDohodaScreen({
		mainBlockPath: ipotekaBezDohodaMainBlock,
		ratePoints: [
			'Без подтверждения дохода, при первоначальном взносе от 40%',
			'Низкая ставка от 4,5% годовых',
			'Предварительное решение в день одобрения',
			'Быстрый выход на сделку',
			'Доступны льготные программы',
		],
		minLoan: 100000,
		maxLoan: 500000,
		isAutoLoan: false,
	})

const pageProps = requireNotNull(regionalPagesProps[RegionalPagesPath.personalNaIpotekuBezDohoda])
IpotekaBezDohodaPage.layout = pageProps.layout
IpotekaBezDohodaPage.headProps = pageProps.headProps

export const getServerSideProps = serverSideResolveCity

export default IpotekaBezDohodaPage
